import {
  Card,
  CardContent,
  Grid,
  Typography,
  useMediaQuery
} from '@mui/material'

//Icons
import Calendar from '../../../assets/Icons/calendar-icon.png'
import CalendarTerm from '../../../assets/Icons/video-time.png'
import Amount from '../../../assets/Icons/coin.png'

import { useStyles } from './CardCurrentApplicationStyles.js'
import CurrentLoanDetails from '../../../Components/AtomicDesign/molecules/CurrentLoanDetails/CurrentLoanDetails'
import Separator from '../../../Components/AtomicDesign/atoms/Separator/Separator'
import React from 'react'

const CardCurrentApplication = ({ CurrentDetails, children }) => {
  const classes = useStyles()

  return (
    <Card className={classes.card}>
      <div className={classes.greenLine}></div>
      <CardContent className={classes.content}>
        <div className={classes.mainContainer}>
          <div className={classes.imageContainer}>
            <img
              src={CurrentDetails?.cardDetails?.img}
              alt={CurrentDetails?.cardDetails?.title || 'Your Card'}
              className={classes.cardImage}
            />
          </div>
          <Grid container className={classes.detailsContainer}>
            <Grid container direction='row' alignItems='center' xs={12} md={12} className={classes.titleContainer}>
              <Typography className={classes.CustomTitle}>
                {CurrentDetails?.cardDetails?.title || 'Your Card'}
              </Typography>

              <span className={classes.separator}>•</span>
                <Typography
                  margin={'0px'}
                  className={classes.statusText}
                  style={{
                    color:
                      CurrentDetails.status.id === 1 ||
                      CurrentDetails.status.id === 2 ||
                      CurrentDetails.status.id === 5 ||
                      CurrentDetails.status.id === 6
                        ? '#56AF31'
                      : CurrentDetails.status.id === 3 ||
                        CurrentDetails.status.id === 4 ||
                        CurrentDetails.status.id === 8 ||
                        CurrentDetails.status.id === 9 ||
                        CurrentDetails.status.id === 13
                        ? '#f2994a'
                      : CurrentDetails.status.id === 7
                        ? '#FF0606'
                        : '#0F5CAC'
                  }}
                >
                  {CurrentDetails.status?.customerTitle}
                </Typography>
                {CurrentDetails?.status?.declinedReasonDescription && (
                  <React.Fragment>
                    <span className={classes.separator}>•</span>
                    <Typography
                      className={classes.declinedReason}
                    >
                      {CurrentDetails?.status?.declinedReasonDescription}
                    </Typography>
                  </React.Fragment>
                )}
            </Grid>
            <Separator />
            <div className={classes.detailsGrid}>
              <CurrentLoanDetails
                Icon={Calendar}
                Key={'START DATE'}
                Value={
                  CurrentDetails?.datesDetails?.applicationDate
                    ? new Date(
                        CurrentDetails.datesDetails.applicationDate
                      ).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      })
                    : '-- -- --'
                }
              />
              <CurrentLoanDetails
                Icon={Amount}
                Key={'AMOUNT'}
                Value={
                  !CurrentDetails?.limitDetails?.approved || (CurrentDetails?.limitDetails?.approved === CurrentDetails?.limitDetails?.requested)
                    ? `$${CurrentDetails?.limitDetails?.requested || '--'}`
                    : undefined
                }
              >
                {(CurrentDetails?.limitDetails?.approved !== CurrentDetails?.limitDetails?.requested) && (CurrentDetails?.limitDetails?.approved > 0) && (
                  <div className={classes.amountContainer}>
                    <Typography className={classes.approvedAmount}>
                      ${CurrentDetails.limitDetails.approved}
                    </Typography>
                    {CurrentDetails?.limitDetails?.requested && (
                      <>
                        <Typography className={classes.arrowIcon}>←</Typography>
                        <Typography className={classes.requestedAmount}>
                          ${CurrentDetails.limitDetails.requested}
                        </Typography>
                      </>
                    )}
                  </div>
                )}
              </CurrentLoanDetails>
              <CurrentLoanDetails
                Icon={Calendar}
                Key={'SUBMISSION DATE'}
                Value={
                  CurrentDetails?.datesDetails?.submittedDate
                    ? new Date(
                        CurrentDetails.datesDetails.submittedDate
                      ).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                      })
                    : '-- -- --'
                }
              />
              <CurrentLoanDetails
                Icon={CalendarTerm}
                Key={'SUPPLEMENTARY'}
                Value={
                  CurrentDetails?.supplementaryCardHolder === true ? 'YES' : 'NO'
                }
              />
            </div>
            {children}
          </Grid>
        </div>
      </CardContent>
    </Card>
  )
}

export default CardCurrentApplication
